// @flow
import type { ReduxState } from '../../types';

export const getIsPlayingCasino = (state: ReduxState) =>
  state.location.isPlayingCasino;
